import React, {useEffect, useMemo, useState} from "react";
import "./AnimatedBackground.scss";

const PARTICLES = Array.from({length: 12}, (_, i) => ({
  id: i,
  left: `${(i * 19 + 5) % 100}%`,
  top: `${(i * 29 + 8) % 100}%`,
  size: 3 + (i % 4),
  delay: `${(i % 8) * 0.45}s`,
  duration: `${7 + (i % 6)}s`
}));

export default function AnimatedBackground({isDark = false}) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  const particles = useMemo(
    () => (isMobile ? PARTICLES.slice(0, 6) : PARTICLES),
    [isMobile]
  );

  return (
    <div
      className={`animated-bg${
        isDark ? " animated-bg-dark" : " animated-bg-light"
      }${isMobile ? " animated-bg-mobile" : ""}`}
      aria-hidden="true"
    >
      <div className="bg-gradient-shift" />
      <div className="bg-aurora" />
      <div className="bg-aurora bg-aurora-2" />
      <span className="bg-blob bg-blob-1" />
      <span className="bg-blob bg-blob-2" />
      <span className="bg-blob bg-blob-3" />
      {!isMobile && <span className="bg-blob bg-blob-4" />}
      <div className="bg-grid" />
      <div className="bg-particles">
        {particles.map(p => (
          <span
            key={p.id}
            className="bg-particle"
            style={{
              left: p.left,
              top: p.top,
              width: p.size,
              height: p.size,
              animationDelay: p.delay,
              animationDuration: p.duration
            }}
          />
        ))}
      </div>
      {isDark && <div className="bg-vignette" />}
      {!isDark && <div className="bg-vignette bg-vignette-light" />}
    </div>
  );
}
